export const ddpVersionOptions = ["v2", "v5"];
export const ipVersionOptions = [4, 6];

export const socketIdTypeOption = {
  discovery: 'discovery',
  auth: 'auth',
  ipSetting: 'ipSetting',
  adopt: 'adopt',
}

export const defaultUser = {
  username: "admin",
  password: "admin",
}

export const scopeLevelOption = {
  msp: "MSP".toLowerCase(),
  org: "ORG".toLowerCase(),
  site: "SITE".toLowerCase(),
}

export const protocolTypeOption = {
  nc: "nc",
  unity: "unity",
  snmp: "snmp",
};

export const authStateOption = {
  passed: "passed",
  failed: "failed",
}

export const deviceTypeOption = {
  ap: {
    label: "AP",
    value: "Access Point",
  },
  switch: {
    label: "Switch",
    value: "Switch",
  },
  gateway: {
    label: "GW",
    value: "Gateway",
  },
  proxy: {
    label: "Proxy",
    value: "proxy",
  },
  unknown: {
    label: "Unknown",
    value: "unknown",
  },
}

export const deviceRegistrationStateOption = {
  registered: "registered",
  unregistered: "unregistered",
};

export const deviceLinkStatusOption = {
  online: "online",
  offline: "offline",
  onboarding: "onboarding",
};

export const deviceStatusOption = {
  unmanaged: {
    label: "Unmanaged",
    value: "unmanaged",
  },
  offline: {
    label: "Offline",
    value: "offline",
  },
  onboarding: {
    label: "Onboarding",
    value: "onboarding",
  },
  configurable: {
    label: "Configurable",
    value: "configurable",
  },
  authenticationRequired: {
    label: "Authentication Required",
    value: "authenticationRequired",
  },
  provisioning: {
    label: "Provisioning",
    value: "provisioning",
  },
  managedByOthers: {
    label: "Managed by Others",
    value: "managedByOthers",
  },
  failedToAdopt: {
    label: "Failed to Adopt",
    value: "failedToAdopt",
  },
}

export const defaultIpModeState = {
  static: {
    label: "Static IP",
    value: "static",
  },
  dhcp: {
    label: "Dynamic IP(DHCP)",
    value: "dhcp",
  },
}

export const defaultColumns = [
  {
    id: "checkbox",
    label: "",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "status",
    label: "Status",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "auth",
    label: "Auth",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "modelName",
    label: "Model name",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "macAddress",
    label: "MAC address",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "ipAddress",
    label: "IP address",
    visible: true,
    draggable: false,
    direction: null,
  }
];

export const defaultLayer3Type = {
  select: {
    title: 'Select',
    value: 'select',
  },
  ip: {
    title: 'IP',
    value: 'ip',
  },
  subnet: {
    title: 'Subnet',
    value: 'subnet',
  },
}

export const defaultLayer3Setting = {
  type: defaultLayer3Type.ip,
  startIp: '',
  startIpErr: false,
  endIp: '',
  endIpErr: false,
  endIpSmallerErr: false,
  range: '',
  rangeErr: false,
};

export const defaultLayerSetting = {
  layer2: {
    value: true,
  },
  layer3: {
    value: false,
    configures: [
      {
        type: defaultLayer3Type.select,
        startIp: '',
        startIpErr: false,
        endIp: '',
        endIpErr: false,
        range: '',
        rangeErr: false,
      },
    ],
  },
};

export const defaultAdoptionColumns = [
  {
    id: "modelName",
    label: "Model Name",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "macAddress",
    label: "MAC address",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "ipAddress",
    label: "IP address",
    visible: true,
    draggable: false,
    direction: null,
  },
  {
    id: "result",
    label: "Result",
    visible: false,
    draggable: false,
    direction: null,
  },
];

export const adoptionSourceType = {
  byRow: 'byRow',
  byCheckboxWithIpSettings: 'byCheckboxWithIpSettings',
  byCheckboxWithAuthenticate: 'byCheckboxWithAuthenticate',
  byCheckboxWithAdoption: 'byCheckboxWithAdoption',
}

export const adoptionProcessType = {
  site: 'site',
  ipSettings: 'ipSettings',
  authenticate: 'authenticate',
  final: 'final',
}

export const adoptionSourceProcess = {
  byRow: [adoptionProcessType.site, adoptionProcessType.final],
  byCheckboxWithIpSettings: [adoptionProcessType.ipSettings, adoptionProcessType.site, adoptionProcessType.final],
  byCheckboxWithAuthenticate: [adoptionProcessType.authenticate, adoptionProcessType.site, adoptionProcessType.final],
};

export const scanningTimeout = 5 * 60; // 5 minutes
export const otherTimeout = 30; // 30 seconds